var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnexoGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2087_112043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.09258 3.28346L4.64391 7.41618C4.64391 7.41618 3.8484 8.2413 4.89986 8.86041C5.84798 9.41867 6.57177 8.55132 6.57177 8.55132L10.1988 4.20485C10.1988 4.20485 11.1502 3.06479 9.80067 2.27019C8.45117 1.47559 7.49981 2.61565 7.49981 2.61565L3.87276 6.96212C3.87276 6.96212 2.50519 8.60096 4.24026 9.62259C5.97534 10.6442 7.34291 9.00538 7.34291 9.00538L10.97 4.6589C11.1186 4.48077 10.733 4.25374 10.5844 4.43187L6.95734 8.77835C6.95734 8.77835 6.00039 10.1759 4.51053 9.29871C3.16103 8.50411 4.25834 7.18915 4.25834 7.18915L7.88539 2.84267C7.88539 2.84267 8.56647 2.0265 9.5304 2.59407C10.4943 3.16164 9.81325 3.97782 9.81325 3.97782L6.1862 8.32429C6.1862 8.32429 5.7597 8.83539 5.19715 8.50415C4.63461 8.17292 5.02948 7.64321 5.02948 7.64321L8.47815 3.51049C8.6268 3.33236 8.24123 3.10533 8.09258 3.28346Z",
    fill: "#696868"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2087_112043"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.84381,
    height: 9.28039,
    fill: "white",
    transform: "matrix(0.861718 0.507388 -0.640704 0.767788 5.94531 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnexoGray);
export default __webpack_public_path__ + "static/media/anexo_gray.bac9272fa1e94f9a70e120f012995e7b.svg";
export { ForwardRef as ReactComponent };